const initials = "category/";
export const SELECTED_CATEGORY = `${initials}SELECTED_CATEGORY`;
export const DESELECTED_CATEGORY = `${initials}DESELECTED_CATEGORY`;
